import { AudioManager } from './AudioManager';
import { GameManager } from "./GameManager";
import { GameConstants } from "../GameConstants";
import { HiLoCardsContainer } from "../scenes/hi-lo/HiLoCardsContainer";
import { Bot } from "../scenes/room/bot/Bot";
import { GameVars } from "../GameVars";
import { HiLoHUD } from "../scenes/hi-lo/HiLoHUD";
import { HiLoScene } from "../scenes/hi-lo/HiLoScene";

export class HiLoManager {

    public static deck: string [];

    private static currentCardValue: string;

    public static init(): void {

        GameVars.paused = false;
        
        HiLoManager.deck = [];
        
        HiLoManager.initGame();
    }

    public static getCard(): string {
        
        HiLoManager.currentCardValue = HiLoManager.deck.pop();

        return HiLoManager.currentCardValue;
    }

    public static onBetPlaced(bet: string): void {

        const previousCardValue = HiLoManager.currentCardValue;

        HiLoCardsContainer.currentInstance.addCard(HiLoManager.getCard());

        GameVars.hiLoRemainingCards --;
        HiLoHUD.currentInstance.updateCardsCounter();

        // comparar los valores
        const isHigher = Bot.cardValue(previousCardValue) < Bot.cardValue(HiLoManager.currentCardValue);
        
        if (isHigher && bet === GameConstants.HIGHER || !isHigher && bet === GameConstants.LOWER) {
            GameVars.hiLoScore += 100;
            GameVars.hiLoExtraHearts++;

            HiLoHUD.currentInstance.showPlusPointsLabel();
            HiLoHUD.currentInstance.updateExtraHearts();

            AudioManager.playSound("correct_guess");
        } else {
            // descontar un corazon
            GameVars.hiLoHearts --;
            GameVars.hiLoScore -= 100;
            GameVars.hiLoExtraHearts = 0;

            HiLoHUD.currentInstance.showSubPointsLabel();
            HiLoHUD.currentInstance.updateExtraHearts();

            HiLoScene.currentInstance.onHeartLost();

            AudioManager.playSound("wrong_guess");
        }

        HiLoHUD.currentInstance.updateScore();

        if (GameVars.hiLoHearts === 0) {
            HiLoManager.onGameOver();
        } else if (GameVars.hiLoRemainingCards === 0) {
            HiLoManager.onGameCompleted();
        } else if (GameVars.hiLoExtraHearts === 5) {
            if (GameVars.hiLoHearts < 3) {
                GameVars.hiLoHearts++;
                HiLoManager.onExtraHeart();
                HiLoHUD.currentInstance.updateHearts();
                AudioManager.playSound("correct_guess_streak");
            }
            GameVars.hiLoExtraHearts = 0;
        }
    }

    public static onReplay(): void {

        HiLoManager.initGame();

        HiLoScene.currentInstance.onReplay();
    }

    public static showInfoLayer(): void {

        GameVars.paused = true;

        HiLoScene.currentInstance.showInfoLayer();
    }

    public static hideInfoLayer(): void {

        GameVars.paused = false;

        HiLoScene.currentInstance.hideInfoLayer();
    }

    public static onGameOver(): void {
        
        HiLoScene.currentInstance.onGameOver();

        GameVars.gameData.highLowConsecutiveWins = 0;
        GameManager.writeGameData();
    }

    public static onGameCompleted(): void {

        GameVars.gameData.chips += GameVars.hiLoScore;

        HiLoScene.currentInstance.onGameCompleted();

        GameVars.gameData.highLowWins++;
        GameVars.gameData.highLowConsecutiveWins++;
        GameManager.writeGameData();

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

            if (GameVars.gameData.highLowConsecutiveWins === 3) {

                var api_awards = [];
                api_awards.push("bananan_pokerg_vkma004");
                LaggedAPI.Achievements.save(api_awards, function(response) {
                    if (response.success) {
                        console.log("achievement saved");
                    } else {
                        console.log(response.errormsg);
                    }
                });
            }
        }

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

            var api_awards = [];

            if (GameVars.gameData.highLowConsecutiveWins === 3) {
                api_awards.push("bananan_pokerg_vkma004");
            }

            if (GameVars.gameData.highLowWins === 10) {
                api_awards.push("bananan_pokerg_vkma005");
            }

            if (api_awards.length > 0) {    
                LaggedAPI.Achievements.save(api_awards, function(response) {
                    if (response.success) {
                        console.log("achievement saved");
                    } else {
                        console.log(response.errormsg);
                    }
                });
            }
        }
    }

    private static onExtraHeart(): void {

        HiLoScene.currentInstance.onExtraHeart();
    }

    private static initGame(): void {

        GameVars.hiLoScore = 0;
        GameVars.hiLoRemainingCards = 12;
        GameVars.hiLoHearts = 3;
        GameVars.hiLoExtraHearts = 0;

        const rnd = Math.floor(Math.random() * 4);

        let suit: string;

        switch (rnd) {
            case 0:
                suit = GameConstants.SUIT_HEARTS;
                break;
            case 1: 
                suit = GameConstants.SUIT_CLUBS;
                break;
            case 2:
                suit = GameConstants.SUIT_SPADES;
                break;
            case 3:
                suit = GameConstants.SUIT_DIAMONDS;
                break;
            default:
        }

        let deck = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "T", "J", "Q", "K"];

        for (let i = 0; i < deck.length; i ++) {
            deck[i] += suit;
        }

        deck = Phaser.Utils.Array.Shuffle(deck);

        HiLoManager.deck = deck.splice(0);
    }
}
